import { combineReducers, configureStore } from '@reduxjs/toolkit';
import websocketReducer from './slices/websocketSlice';
import jwtReducer from './slices/jwtSlice';
import sessionReducer from './slices/sessionSlice';
import thresholdRangeReducer from './slices/thresholdRangeSlice/thresholdRangeSlice';
import productsReducer from './slices/productsSlice/productsSlice';
import toastNotifReducer from './slices/toastNotificationSlice/toastNotificationSlice';
import alertEventsReducer from './slices/alertEvents/alertEventsSlice';
import deviceListReducer from './slices/deviceList/deviceListSlice';
import metricGroupsReducer from './slices/metricsGroupSlice/metricsGroupSlice';
import conversationReducer from './slices/conversation/conversationSlice';
import singleAlertReducer from './slices/singleAlertSlice/singleAlertSlice';
import selectedAlertEventsReducer from './slices/selectedAlertEventsSlice/selectedAlertEventsSlice';
import savedSearchesReducer from './slices/savedSearchesSlice/savedSearchesSlice';
import alertListSlice from './slices/alertListSlice/alertListSlice';
import tagListSlice from './slices/tagListSlice/tagListSlice';
import filteredDeviceListSlice from './slices/filteredDeviceListSlice/filteredDeviceListSlice';
import linkListSliceReducer from './slices/linkListSlice/linkListSlice';
import notificationGroupsReducer from './slices/notificationGroupsSlice/notificationGroupsSlice';
import notificationTemplatesReducer from './slices/notificationTemplatesSlice/notificationTemplatesSlice';
import quietTimesReducer from './slices/quietTimesSlice/quietTimesSlice';
import singleDeviceReducer from './slices/singleDeviceSlice/singleDeviceSlice';
import subscriptionChecklistReducer from './slices/subscriptionChecklistSlice/subscriptionChecklistSlice';
import websocketMiddleware from './middleware/websocketMiddleware';
import jwtMiddleware from './middleware/jwtMiddleware';
import securityMiddleware from './middleware/securityMiddleware';
import dataMiddleware from './middleware/dataMiddleware';
import localStorageMiddleware from './middleware/localStorageMiddleware';
import alertFormReducer from './slices/alertFormSlice/alertFormSlice';
import channelListReducer from './slices/channelListSlice/channelListSlice';
import userListReducer from './slices/userListSlice/userListSlice';
import billingSliceReducer from './slices/billingSlice/billingSlice';
import servicePlanWorkflowSliceReducer from './slices/servicePlanWorkflowSlice/servicePlanWorkflowSlice';

const rootReducer = combineReducers({
  websocket: websocketReducer,
  jwt: jwtReducer,
  session: sessionReducer,
  thresholdRange: thresholdRangeReducer,
  products: productsReducer,
  toastNotifications: toastNotifReducer,
  alertEvents: alertEventsReducer,
  deviceList: deviceListReducer,
  metricGroups: metricGroupsReducer,
  conversation: conversationReducer,
  singleAlert: singleAlertReducer,
  selectedAlertEvents: selectedAlertEventsReducer,
  savedSearches: savedSearchesReducer,
  alertList: alertListSlice,
  tagList: tagListSlice,
  filteredDeviceList: filteredDeviceListSlice,
  linkList: linkListSliceReducer,
  notificationGroups: notificationGroupsReducer,
  notificationTemplates: notificationTemplatesReducer,
  quietTimes: quietTimesReducer,
  singleDevice: singleDeviceReducer,
  subscriptionChecklist: subscriptionChecklistReducer,
  alertForm: alertFormReducer,
  channelList: channelListReducer,
  userList: userListReducer,
  billing: billingSliceReducer,
  servicePlanWorkflow: servicePlanWorkflowSliceReducer,
});

export const setupStore = (preloadedState) => configureStore({
  reducer: rootReducer,
  preloadedState,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(websocketMiddleware)
    .concat(jwtMiddleware)
    .concat(securityMiddleware)
    .concat(dataMiddleware)
    .concat(localStorageMiddleware),
});
export const store = setupStore();
export default store;
